import React, { useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import CharacterProfileForm from './CharacterProfileForm';

const AddCharacterModal = ({ isOpen, onClose, onSave }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e?.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4">
      <div 
        className="absolute inset-0 bg-background/80 backdrop-blur-sm"
        onClick={onClose}
      />
      
      <div className="relative w-full max-w-2xl bg-card rounded-xl shadow-warm-2xl max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-card border-b border-border p-4 md:p-6 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/20 flex items-center justify-center">
              <Icon name="UserPlus" size={24} color="var(--color-primary)" />
            </div>
            <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold">
              Add New Character
            </h2>
          </div>
          
          <button
            onClick={onClose}
            className="w-10 h-10 rounded-lg hover:bg-muted transition-all duration-250 flex items-center justify-center"
            aria-label="Close modal"
          >
            <Icon name="X" size={24} color="var(--color-foreground)" />
          </button>
        </div>

        <div className="p-4 md:p-6 lg:p-8">
          <CharacterProfileForm
            character={null}
            onSave={onSave}
            onCancel={onClose}
          />
        </div>
      </div>
    </div>
  );
};

export default AddCharacterModal;